import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }


import PermissionLink from '@/components/PermissionLink.vue'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'LinkOrder',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
  },
  name: {
    type: String,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (props.id && props.name)
    ? (_openBlock(), _createBlock(PermissionLink, {
        key: 0,
        to: {
        name: 'order-detail',
        params: { id: props.id },
      },
        role: ['sessionInfo']
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tooltip, {
            content: props.id,
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(PreWithEllipsis, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, "-"))
}
}

})